import appSettingsSDK from './AppSettingsSDK';

export default appSettingsSDK;
